export const styles = {
  container: {
    borderBottom: '1px solid #EDEFF7',
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flex: 1,
  },
  projectNameTypo: {
    fontFamily: 'Inter',
    color: '#23252F',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '146%',
  },
  locationContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  locationTypo: {
    fontFamily: 'Inter',
    color: '#23252F',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '150%',
  },
  createdAtTypo: {
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '150%',
    fontWeight: 400,
    color: '#6E707A',
  },
};
